export const content = {
  imageAlt: 'Site in maintenance.',
  title: 'Site in maintenance',
  message:
    "We're doing some maintenance at the moment. Come back soon. Sorry for any inconvenience.",
  endAtPrefix: 'The maintenance is expected to complete at',
  signoff: '— The SMARTY team.',
  goToWebsiteLabel: 'Go to website',
  goToWebsiteHref: '/',
}
